<template>
  <div class="d-flex flex-column flex-grow-1" style="overflow-y: hidden">
    <div v-if="moduleConfig" class="DutyActivitiesAndDocuments-header1 op-header d-flex">
      <rounded-button
        class="width-50-pct"
        :is-selected="tabItem === 'duty'"
        @click="tabItem = 'duty'"
        :label="$t('myDuty.title') + ` ${duty ? duty.dutyname : ''}`"
        isTab
      >
      </rounded-button>
      <rounded-button
        v-if="!hideDutyDocuments"
        class="width-50-pct"
        :is-selected="tabItem === 'documents'"
        @click="tabItem = 'documents'"
        :label="$t('fahrdienst452.documents')"
        :showBadge="concernedTrackDocumentsUnreadCount > 0"
        :badgeColor="theme.unreadBadgeColor"
        :offsetX="0"
        :offsetY="-3"
        :count="concernedTrackDocumentsUnreadCount"
        isTab
      >
        <!-- <number-badge v-if="concernedTrackDocumentsUnreadCount>0"
                                                                                                                                                                                                                                              :count="concernedTrackDocumentsUnreadCount"></number-badge> -->
      </rounded-button>
    </div>
    <div class="DutyActivitiesAndDocuments-header2 headerColor d-flex" v-if="tabItem === 'duty'">
      <div class="d-flex justify-items-center pt-3 full-width">
        <v-checkbox
          v-if="!hideMergeAllDutiesCheckbox"
          class="ml-2"
          small
          dense
          v-model="mergeAllDuties"
          :color="theme.unreadBadgeColor"
          :label="$t('myD.showTurnaroundTimes')"
        ></v-checkbox>
        <div class="d-flex flex-grow-1 justify-end pr-1">
          <slot name="header2Right"></slot>
        </div>
      </div>
    </div>
    <!-- relative style important to scroll Perlschnur dots -->
    <div class="DutyActivitiesAndDocuments-content d-flex flex-grow-1 scroll-container" style="position: relative">
      <duty-activities
        v-if="tabItem === 'duty'"
        :mergeAllDuties="mergeAllDuties"
        :duty="duty"
        :dutyActivities="dutyActivities"
        @onDutyActivitySelected="displayDutyActivityTracks"
        @onDutyActivityLineSelected="displayDutyActivityTracksOfOneTrack"
      >
      </duty-activities>
      <fahrdienst-docs-by-doc-type
        v-if="tabItem === 'documents'"
        :showFooter="false"
        :showFilter="true"
        :showSorting="true"
        v-model="concernedTrackDocumentsOnly"
        :categories="fahrdienst452FileTypes"
        :selectedDocument="displayedDocument"
        :filteredDocuments="concernedTrackDocuments"
        :filteredDisplayText="relevantDocsText"
        :totalUnreadCount="unreadCount"
        categoryPropertyName="typeIdFk"
        @docSelected="displayFile"
      >
      </fahrdienst-docs-by-doc-type>
    </div>
  </div>
</template>
<script>
import RoundedButton from '@/components/buttons/RoundedButton.vue';
import DutyActivities from '@/modules/myDuties/dutyActivities/DutyActivities.vue';
import FahrdienstDocsByDocType from '@/components/fahrdienstDocs/FahrdienstDocsByDocType.vue';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import { mapState } from 'vuex';
import MODULE_ID from '@/modules/myDuties/moduleId';
import fahrdienst452Service from '@/modules/fahrdienst452/fahrdienst452Service';
import tenantStrategies from '../dutyActivities/tenantStrategies';
import index from '@/modules/myDuties';
const MERGE_ALL_DUTIES_PREFERENCES = 'myDuty/mergeAllDuties';
export default {
  name: 'DutyActivitiesAndDocuments',
  mixins: [dutyMixin, common, configMixin],
  components: { FahrdienstDocsByDocType, DutyActivities, RoundedButton },
  props: {
    duty: Object,
    dutyActivities: Array,
  },
  data() {
    return {
      tabItem: 'duty',
      concernedTrackDocumentsOnly: true,
      mergeAllDuties: null,
    };
  },
  mounted() {
    const localStorageMergeAllDuties = localStorage.getItem(MERGE_ALL_DUTIES_PREFERENCES);
    this.mergeAllDuties = localStorageMergeAllDuties !== null ? JSON.parse(localStorageMergeAllDuties) : this.mergeAllDutiesDefault;
    console.debug('this.mergeAllDuties', this.mergeAllDuties);
  },
  computed: {
    ...mapState({ tenant: (state) => state.profile.customerRelations.tenant }),
    ...mapState(MODULE_ID, ['isLoaded', 'displayMode', 'displayedDocument', 'displayedDutyPart']),
    ...mapState('fahrdienst452', ['fahrdienst452FileTypes', 'fahrdienst452File', 'unreadCount']),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    mergeAllDutiesDefault() {
      console.debug(`this.moduleConfig=${JSON.stringify(this.moduleConfig, null, 2)}`);
      console.debug('this.moduleConfig.mergeAllDutiesByDefault', this.moduleConfig.mergeAllDutiesByDefault);
      return this.moduleConfig.mergeAllDutiesByDefault || false;
    },
    hideMergeAllDutiesCheckbox() {
      return !!this.moduleConfig.hideMergeAllDutiesCheckbox;
    },
    hideDutyDocuments() {
      return !!this.moduleConfig.hideDutyDocuments;
    },
    concernedTrackDocumentsUnreadCount() {
      if (this.unreadCount > 0) {
        // check required because unreadCount is reactive whereas concernedTrackDocuments is not
        return this.concernedTrackDocuments.filter((file) => !file._userState || !file._userState.dateread).length;
      }
      return 0;
    },
    relevantDocsText() {
      return this.$t('fahrdienst452.displayTrackRelatedDocs', { tracks: this.concernedTrackNumbers.join(', ') });
    },
    /**
     * Find out all track numbers (Kurse) which are involved within the duty activities.
     */
    concernedTrackNumbers() {
      let trackNumbers = !this.dutyActivities
        ? []
        : this.dutyActivities
            .filter((da) => da.course !== null)
            .map((da) => Number(da.course))
            .sort()
            .filter((item, pos, array) => {
              return !pos || item != array[pos - 1];
            });
      console.debug('concernedTrackNumbers', JSON.stringify(trackNumbers, null, 2));

      return trackNumbers;
    },
    concernedTrackDocuments() {
      let concernedTrackNumbers = this.concernedTrackNumbers;
      let date = this.duty ? new Date(Date.parse(this.duty.day)) : new Date();

      return fahrdienst452Service.filterDocuments({
        fahrdienst452Files: this.fahrdienst452File,
        filterByLineOrTrack: this.concernedTrackDocumentsOnly,
        lines: [],
        tracks: concernedTrackNumbers,
        selectedDate: date,
        fahrdienst452FileFilteringColumns: ['linie', 'kurs'],
      });
    },
  },
  methods: {
    displayFile(file) {
      this.dmx_markAsRead(file);

      this.$router.push(`/myduties/detail/${this.duty.id}/${file.id}`);
      if (this.mdAndDown) {
        this.mx_isLeftDrawerOpen = false;
      }
    },
    /**
     * Display the tour associated with the duty, day, line and track
     */
    displayDutyActivityTracks(dutyActivity) {
      this.mx_isLeftDrawerOpen = false;
      console.debug('displayDutyActivityTracks', dutyActivity);
      let duty = this.duty;

      this.dateIsoString = duty.day;
      this.track = dutyActivity.course;
      if (dutyActivity.course !== dutyActivity.blockcode) {
        console.warn('dutyActivity.course', dutyActivity.course, 'does not match dutyActivity.blockcode', dutyActivity.blockcode);
      }
      let specs = tenantStrategies.getTrackSpecificationFromDutyActivity({ tenant: this.tenant, dutyActivity });
      // apply only set properties, e.g. CVAG does set the track contrary to the default
      if (specs.track) this.track = specs.track;
      if (specs.line) this.line = specs.line;
      if (specs.blockcode) this.blockcode = specs.blockcode;
      if (specs.startToMinutesAfterMidnight) this.startToMinutesAfterMidnight = specs.startToMinutesAfterMidnight;
      if (specs.endToMinutesAfterMidnight) this.endToMinutesAfterMidnight = specs.endToMinutesAfterMidnight;

      let { dateIsoString, track, line, startToMinutesAfterMidnight, endToMinutesAfterMidnight } = this;
      // console.debug('selection', JSON.stringify({ dateIsoString, track, line, startToMinutesAfterMidnight, endToMinutesAfterMidnight }, null, 2));
      this.$store.commit(`${MODULE_ID}/setDisplayedDutyPart`, {
        duty,
        dateIsoString,
        track,
        line,
        startToMinutesAfterMidnight,
        endToMinutesAfterMidnight,
      });
    },
    displayDutyActivityTracksOfOneTrack(dutyActivity) {
      this.mx_isLeftDrawerOpen = false;
      let duty = this.duty;

      this.dateIsoString = duty.day;
      this.track = dutyActivity.course;
      this.line = dutyActivity.line;
      let firstDutyActivity = this.dutyActivities.find((da) => da.line === this.line && da.course === this.track);
      let lastDutyActivity = this.dutyActivities
        .slice()
        .reverse()
        .find((da) => da.line === this.line && da.course === this.track);
      console.debug('displayDutyActivityTracksOfOneTrack', firstDutyActivity.from);
      this.startToMinutesAfterMidnight = firstDutyActivity.fromMinutesAfterMidnight;
      this.endToMinutesAfterMidnight = lastDutyActivity.toMinutesAfterMidnight;

      let { dateIsoString, track, line, startToMinutesAfterMidnight, endToMinutesAfterMidnight } = this;
      // console.debug('selection', JSON.stringify({ dateIsoString, track, line, startToMinutesAfterMidnight, endToMinutesAfterMidnight }, null, 2));
      this.$store.commit(`${MODULE_ID}/setDisplayedDutyPart`, {
        duty,
        dateIsoString,
        track,
        line,
        startToMinutesAfterMidnight,
        endToMinutesAfterMidnight,
      });
    },
  },
  watch: {
    mergeAllDuties(newValue, oldValue) {
      console.debug(`mergeAllDuties changed from ${newValue} to ${oldValue}`);
      localStorage.setItem(MERGE_ALL_DUTIES_PREFERENCES, newValue);
    },
    tabItem(newValue, oldValue) {
      if (oldValue === 'documents' && newValue === 'duty' && this.duty) {
        if (this.$route.path !== `/myduties/detail/${this.duty.id}`) {
          this.$router.push(`/myduties/detail/${this.duty.id}`);
        }
      }
    },
  },
};
</script>
